import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import {
  mdiAccount,
  mdiLock,
  mdiPhone,
  mdiCloseCircle
} from '@mdi/js'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false
  },
  icons: {
    iconFont: 'mdiSvg',
    values: {
      account: mdiAccount,
      lock: mdiLock,
      phone: mdiPhone,
      close: mdiCloseCircle,
      delete: mdiCloseCircle
    }
  }
})
